<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_17558_225061"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        d="M4 19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V5C20 3.89543 19.1046 3 18 3H6C4.89543 3 4 3.89543 4 5V19ZM4 19C4 17.8954 4.89543 17 6 17H17C18.6569 17 20 15.6569 20 14M15 7H8M13 11L8 11"
        stroke="black"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </mask>
    <g mask="url(#mask0_17558_225061)">
      <rect width="24" height="24" fill="#39444C" />
    </g>
  </svg>
</template>
